import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { CalendarEvent } from 'angular-calendar';
import { ReservationsServices } from "../services";
import { Observable } from 'rxjs';
import { ReservationCalendarPage } from "../reservation-calendar/reservation-calendar";
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { ConfigurationServices } from "../../configuration/services";
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';


//interface
interface Reservation {
  UID: string;
  UID_RESTAURANT: string;
  adults: number;
  children: number;
  date: string;
  delete: boolean;
  email: string;
  hour: string;
  message: string;
  name: string;
  phone: number;
  stripe: number;
  uid_client: string;
}

interface Reservation_complete {
  UID: string;
  UID_RESTAURANT: string;
  date: string;
  stripe: number;
  uid_reservation: string;
}

@Component({
  selector: 'page-reservation-loader',
  templateUrl: 'reservation-loader.html',
})
export class ReservationLoaderPage {

  view: string = 'month';
  viewDate: Date = new Date();
  events: CalendarEvent[] = [];
  activeDayIsOpen: boolean = false;
  reservations: any;
  valueChanges: any;
  preparation: any = [];
  reserva: any;

  events$: Observable<Array<CalendarEvent<{ event: Event[] }>>>;

  //preparations:any;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public reservationsServices: ReservationsServices,
    public http: HttpClient,
    public confServices: ConfigurationServices,
    public datePipe: DatePipe,
    public translate: TranslateService) {
  }

  async ionViewWillEnter() {
    if (this.navParams.get('view')) {
      this.view = this.navParams.get('view');
    }
    //open calendar
    this.reservationsServices.book_url = 'https://book.mycheftool.com/' + this.globals.domini_sites;
    await this.getReservations();
    this.reservationsServices.checkReservationsConfig();
    this.navCtrl.setRoot(ReservationCalendarPage, {
      view: this.view
    });
  }

  async getReservations() {
    this.events = [];
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });

    loadingPopup.present();

    if (this.globals.checkIntegrationOpened('covermanager')) {
      var date_first = moment().startOf('month').format("YYYY-MM-DD");
      var date_last = moment().add(60, 'days').format("YYYY-MM-DD");

      await this.http.post(this.globals.api_path + 'reservations/get_reservs_covermanager', {
        convermanaer_api: this.globals.restaurant.covermanager_api,
        covermanager_rest_name: this.globals.restaurant.covermanager_rest_name,
        date_first: date_first,
        date_last: date_last,
        uid: this.globals.restaurant_uid,
      }, {}).subscribe(async data => {
      },
        err => {
        }
      );
    }

    // Limpiar suscripciones anteriores si existen
    if (this.reservationsServices.reservations_complete) {
      this.reservationsServices.reservations_complete = null;
    }

    this.reservationsServices.reservation_completeCol = this.reservationsServices.afs.collection('reservation_complete', ref => ref.where('UID_RESTAURANT', '==', this.globals.restaurant_uid));
    this.reservationsServices.reservations_complete = this.reservationsServices.reservation_completeCol.snapshotChanges().map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Reservation_complete;
        data.UID = a.payload.doc.id;
        return data
      });
    });

    this.reservationsServices.reservations_complete.subscribe(docs => {
      this.reservationsServices.reservations_stripe_complete = docs;
    });

    // Limpiar suscripción anterior si existe
    if (this.reservations) {
      this.reservations = null;
    }

    this.reservationsServices.reservationCol = this.reservationsServices.afs.collection('reservations', ref => ref
      .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .orderBy('date_order', 'asc'));

    this.reservations = this.reservationsServices.reservationCol.snapshotChanges().map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Reservation;
        data.UID = a.payload.doc.id;
        return data
      });
    });

    this.reservations.subscribe(async docs => {
      this.reservationsServices.reservations_info = docs;
      await this.reservationsServices.getReservationsEvents(docs);
      this.reservationsServices.getReservationsByDay();
      loadingPopup.dismiss();
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-loader/reservation-loader.ts